module.exports = {
  siteTitle: 'Maria Ilutuba', // <title>
  manifestName: 'Maria Ilutuba',
  manifestShortName: 'Ilutuba', // max 12 characters
  manifestStartUrl: 'https://mariailutuba.ee/',
  manifestBackgroundColor: '#313a3d',
  manifestThemeColor: '#313a3d',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  //pathPrefix: `/maria-ilutuba/`, // This path is subpath of your hosting https://domain/portfolio
  heading: 'Telli iluteenus',
  subHeading: 'Kvaliteetne maniküür, pediküür ja näohooldus Tartus',
  // social
  socialLinks: [
    {
      icon: 'fa-facebook',
      name: 'Facebook',
      url: 'https://www.facebook.com/mariailutuba',
    },
    {
      icon: 'fa-envelope-o',
      name: 'Email',
      url: 'mailto:mariaarak@hotmail.com',
    },
  ],
};
